import { render, staticRenderFns } from "./PageTooltip.vue?vue&type=template&id=15fc000b&scoped=true&"
import script from "./PageTooltip.vue?vue&type=script&lang=js&"
export * from "./PageTooltip.vue?vue&type=script&lang=js&"
import style0 from "./PageTooltip.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PageTooltip.vue?vue&type=style&index=1&id=15fc000b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc000b",
  null
  
)

export default component.exports